import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMwoKIRyNZe1FCxStb66Z_SLCuu8H3mxE",
  authDomain: "pktraffic-510f4.firebaseapp.com",
  projectId: "pktraffic-510f4",
  storageBucket: "pktraffic-510f4.appspot.com",
  messagingSenderId: "44635827626",
  appId: "1:44635827626:web:9890f48f09b8e4ec178fd3",
  measurementId: "G-T17048G707"
};

// Initialize Firebase
initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);